import { useLanguage } from "../context/LanguageContext";

const SECTIONS = [
  { title: "Services", text: "Evi-Studio produces custom songs, jingles and albums. Private packages (CHF 300) and event songs (from CHF 150) are prepaid by card or Swiss QR bank transfer. Production starts after confirmed receipt of payment. Business jingles and albums are priced by individual written agreement." },
  { title: "Liability for content", text: "The content of this website was created with care. However, we cannot guarantee the accuracy, completeness or timeliness of the content. Links to external third-party websites are outside our responsibility." },
  { title: "Copyright", text: "All songs, lyrics, jingles and recordings showcased on this site are productions of Evi-Studio and may not be reproduced or used commercially without written permission of Evinet.group." },
];

export default function Imprint() {
  const { t } = useLanguage();
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <p className="eyebrow">{t("Legal")}</p>
      <h1 data-testid="imprint-heading" className="mt-3 font-display text-3xl font-extrabold text-slate-50 sm:text-4xl">{t("Imprint")}</h1>
      <div className="mt-10 space-y-8 text-sm leading-relaxed text-slate-400">
        <section data-testid="imprint-operator" className="studio-card p-6">
          <h2 className="font-display text-lg font-semibold text-slate-100">{t("Operator")}</h2>
          <p className="mt-3">{t("Evi-Studio is a service of")}<br /><span className="text-slate-100">Evinet.group</span><br />{t("Switzerland")}</p>
          <p className="mt-3">{t("Email:")} <span className="font-mono text-slate-300">hello@evinet.group</span><br />{t("Web:")} <span className="font-mono text-slate-300">evinet.group</span></p>
        </section>
        {SECTIONS.map((section, index) => (
          <section key={section.title} data-testid={`imprint-section-${index + 1}`}>
            <h2 className="font-display text-lg font-semibold text-slate-100">{t(section.title)}</h2>
            <p className="mt-2">{t(section.text)}</p>
          </section>
        ))}
      </div>
    </div>
  );
}